module.exports = __webpack_public_path__ + "img/logo_tiny.2da003b2.png";